import { FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Paper, Radio, Select } from '@material-ui/core';
import React from 'reactn';
import { NumberField } from '../../components/NumberField';
import { globalStyles } from '../../style/GlobalStyles';
import { SchedaBudgetInputProps } from './InformazioniCosti';

export default function DirittoAnnCCIAA(props: SchedaBudgetInputProps) {
    const gClasses = globalStyles();
    const action = "changeCCIAA";
    const { state } = props;
    //const [global] = useGlobal<IGlobalState>();

    const handleChange = (e: any) => {
        props.handleChange(action, e.target.name, e.target.value);
    };

    const handleChangeSelect = (e: any) => {
        handleChange(e);
        //let { name, value } = e.target;
        // API_elaboraSchedaBudget(props, global, name, value, action, true);
    };

    const handleBlur = (e: any) => {
        // API_elaboraSchedaBudget(props, global);
    }

    const handleChangeCheckedRadio = (e: any) => {
        props.handleChange("resetChecksCCIAA", e.target.name, e.target.checked);
        // API_elaboraSchedaBudget(props, global, e.target.name, e.target.checked, action, true);
    }

    // const handleChangeChecked = (e: any) => {
    //     props.handleChange(action, e.target.name, e.target.checked);
    //     // API_elaboraSchedaBudget(props, global, e.target.name, e.target.checked, action, true);
    // }

    return (
        <React.Fragment>
            <Paper className={gClasses.fullWidthPaper}>
                <Grid container spacing={3}>
                    <Grid container spacing={3} alignItems="flex-end">
                        <Grid item>
                            <FormControlLabel className={gClasses.bottomControlLabel}
                                labelPlacement="end"
                                style={{ minWidth: "18rem" }}
                                control={
                                    <Radio
                                        checked={state.dirittiCCIAA.B8_check}
                                        value={state.dirittiCCIAA.B8_check}
                                        name='B8_check'
                                        id='B8_check'
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                        onChange={handleChangeCheckedRadio}
                                    />
                                }
                                label="Ditte individuali (Sezione Speciale)"
                            />
                        </Grid>
                        <Grid item>
                            <NumberField name="H8_sede_principale"
                                label="Sede principale"
                                value={state.dirittiCCIAA.H8_sede_principale}
                                className={gClasses.textFieldReadOnly}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                readOnly={true}
                            ></NumberField>
                        </Grid>
                        <Grid item>
                            <FormControl className={gClasses.formControlCCIAA}>
                                <InputLabel htmlFor="I8_maggiorazione">% Maggiorazione</InputLabel>
                                <Select
                                    className={gClasses.select}
                                    value={state.dirittiCCIAA.I8_maggiorazione}
                                    inputProps={{ name: 'I8_maggiorazione', id: 'I8_maggiorazione' }}
                                    onChange={handleChangeSelect}
                                >
                                    <MenuItem value={0}></MenuItem>
                                    <MenuItem value={20}>20%</MenuItem>
                                    <MenuItem value={70}>70%</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl className={gClasses.formControlCCIAA}>
                                <InputLabel htmlFor="J8_numero_unita_locali">Num. unità locali</InputLabel>
                                <Select
                                    className={gClasses.select}
                                    value={state.dirittiCCIAA.J8_numero_unita_locali}
                                    inputProps={{ name: 'J8_numero_unita_locali', id: 'J8_numero_unita_locali' }}
                                    onChange={handleChangeSelect}
                                >
                                    <MenuItem value={0}></MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    {/* ----------------------9--------------------- */}
                    <Grid container spacing={3} alignItems="flex-end">
                        <Grid item>
                            <FormControlLabel className={gClasses.bottomControlLabel}
                                labelPlacement="end"
                                style={{ minWidth: "18rem" }}
                                control={
                                    <Radio
                                        checked={state.dirittiCCIAA.B9_check}
                                        name='B9_check'
                                        id='B9_check'
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                        onChange={handleChangeCheckedRadio}
                                    />
                                }
                                label="Ditte individuali (Sezione Ordinaria)"
                            />
                        </Grid>
                        <Grid item>
                            <NumberField name="H9_sede_principale"
                                label="Sede principale"
                                value={state.dirittiCCIAA.H9_sede_principale}
                                className={gClasses.textFieldReadOnly}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                readOnly={true}
                            ></NumberField>
                        </Grid>
                        <Grid item>
                            <FormControl className={gClasses.formControlCCIAA}>
                                <InputLabel htmlFor="I9_maggiorazione">% Maggiorazione</InputLabel>
                                <Select
                                    className={gClasses.select}
                                    value={state.dirittiCCIAA.I9_maggiorazione}
                                    inputProps={{ name: 'I9_maggiorazione', id: 'I9_maggiorazione' }}
                                    onChange={handleChangeSelect}
                                >
                                    <MenuItem value={0}></MenuItem>
                                    <MenuItem value={20}>20%</MenuItem>
                                    <MenuItem value={70}>70%</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl className={gClasses.formControlCCIAA}>
                                <InputLabel htmlFor="J9_numero_unita_locali">Num. unità locali</InputLabel>
                                <Select
                                    className={gClasses.select}
                                    value={state.dirittiCCIAA.J9_numero_unita_locali}
                                    inputProps={{ name: 'J9_numero_unita_locali', id: 'J9_numero_unita_locali' }}
                                    onChange={handleChangeSelect}
                                >
                                    <MenuItem value={0}></MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                    </Grid>
                    {/* ----------------------10-------------------- */}
                    <Grid container spacing={3} alignItems="flex-end">
                        <Grid item>
                            <FormControlLabel className={gClasses.bottomControlLabel}
                                labelPlacement="end"
                                style={{ minWidth: "18rem" }}
                                control={
                                    <Radio
                                        checked={state.dirittiCCIAA.B10_check}
                                        name='B10_check'
                                        id='B10_check'
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                        onChange={handleChangeCheckedRadio}
                                    />
                                }
                                label="Società Semplici agricole"
                            />
                        </Grid>
                        <Grid item>
                            <NumberField name="H10_sede_principale"
                                label="Sede principale"
                                value={state.dirittiCCIAA.H10_sede_principale}
                                className={gClasses.textFieldReadOnly}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                readOnly={true}
                            ></NumberField>
                        </Grid>
                        <Grid item>
                            <FormControl className={gClasses.formControlCCIAA}>
                                <InputLabel htmlFor="I10_maggiorazione">% Maggiorazione</InputLabel>
                                <Select
                                    className={gClasses.select}
                                    value={state.dirittiCCIAA.I10_maggiorazione}
                                    inputProps={{ name: 'I10_maggiorazione', id: 'I10_maggiorazione' }}
                                    onChange={handleChangeSelect}
                                >
                                    <MenuItem value={0}></MenuItem>
                                    <MenuItem value={20}>20%</MenuItem>
                                    <MenuItem value={70}>70%</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl className={gClasses.formControlCCIAA}>
                                <InputLabel htmlFor="J10_numero_unita_locali">Num. unità locali</InputLabel>
                                <Select
                                    className={gClasses.select}
                                    value={state.dirittiCCIAA.J10_numero_unita_locali}
                                    inputProps={{ name: 'J10_numero_unita_locali', id: 'J10_numero_unita_locali' }}
                                    onChange={handleChangeSelect}
                                >
                                    <MenuItem value={0}></MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    {/* ----------------------11-------------------- */}
                    <Grid container spacing={3} alignItems="flex-end">
                        <Grid item>
                            <FormControlLabel className={gClasses.bottomControlLabel}
                                labelPlacement="end"
                                style={{ minWidth: "18rem" }}
                                control={
                                    <Radio
                                        checked={state.dirittiCCIAA.B11_check}
                                        name='B11_check'
                                        id='B11_check'
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                        onChange={handleChangeCheckedRadio}
                                    />
                                }
                                label="Società Semplici non agricole"
                            />
                        </Grid>
                        <Grid item>
                            <NumberField name="H11_sede_principale"
                                label="Sede principale"
                                value={state.dirittiCCIAA.H11_sede_principale}
                                className={gClasses.textFieldReadOnly}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                readOnly={true}
                            ></NumberField>
                        </Grid>
                        <Grid item>
                            <FormControl className={gClasses.formControlCCIAA}>
                                <InputLabel htmlFor="I11_maggiorazione">% Maggiorazione</InputLabel>
                                <Select
                                    className={gClasses.select}
                                    value={state.dirittiCCIAA.I11_maggiorazione}
                                    inputProps={{ name: 'I11_maggiorazione', id: 'I11_maggiorazione' }}
                                    onChange={handleChangeSelect}
                                >
                                    <MenuItem value={0}></MenuItem>
                                    <MenuItem value={20}>20%</MenuItem>
                                    <MenuItem value={70}>70%</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl className={gClasses.formControlCCIAA}>
                                <InputLabel htmlFor="J11_numero_unita_locali">Num. unità locali</InputLabel>
                                <Select
                                    className={gClasses.select}
                                    value={state.dirittiCCIAA.J11_numero_unita_locali}
                                    inputProps={{ name: 'J11_numero_unita_locali', id: 'J11_numero_unita_locali' }}
                                    onChange={handleChangeSelect}
                                >
                                    <MenuItem value={0}></MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    {/* ----------------------12-------------------- */}
                    <Grid container spacing={3} alignItems="flex-end">
                        <Grid item>
                            <FormControlLabel className={gClasses.bottomControlLabel}
                                labelPlacement="end"
                                style={{ minWidth: "18rem" }}
                                control={
                                    <Radio
                                        checked={state.dirittiCCIAA.B12_check}
                                        name='B12_check'
                                        id='B12_check'
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                        onChange={handleChangeCheckedRadio}
                                    />
                                }
                                label="Cooperative, Consorzi"
                            />
                        </Grid>
                        <Grid item>
                            <NumberField name="H12_sede_principale"
                                label="Sede principale"
                                value={state.dirittiCCIAA.H12_sede_principale}
                                className={gClasses.textFieldReadOnly}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                readOnly={true}
                            ></NumberField>
                        </Grid>
                        <Grid item>
                            <FormControl className={gClasses.formControlCCIAA}>
                                <InputLabel htmlFor="I12_maggiorazione">% Maggiorazione</InputLabel>
                                <Select
                                    className={gClasses.select}
                                    value={state.dirittiCCIAA.I12_maggiorazione}
                                    inputProps={{ name: 'I12_maggiorazione', id: 'I12_maggiorazione' }}
                                    onChange={handleChangeSelect}
                                >
                                    <MenuItem value={0}></MenuItem>
                                    <MenuItem value={20}>20%</MenuItem>
                                    <MenuItem value={70}>70%</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl className={gClasses.formControlCCIAA}>
                                <InputLabel htmlFor="J12_numero_unita_locali">Num. unità locali</InputLabel>
                                <Select
                                    className={gClasses.select}
                                    value={state.dirittiCCIAA.J12_numero_unita_locali}
                                    inputProps={{ name: 'J12_numero_unita_locali', id: 'J12_numero_unita_locali' }}
                                    onChange={handleChangeSelect}
                                >
                                    <MenuItem value={0}></MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    {/* ----------------------13-------------------- */}
                    <Grid container spacing={3} alignItems="flex-end">
                        <Grid item>
                            <FormControlLabel className={gClasses.bottomControlLabel}
                                labelPlacement="end"
                                style={{ minWidth: "18rem" }}
                                control={
                                    <Radio
                                        checked={state.dirittiCCIAA.B13_check}
                                        name='B13_check'
                                        id='B13_check'
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                        onChange={handleChangeCheckedRadio}
                                    />
                                }
                                label="S.N.C. - S.A.S."
                            />
                        </Grid>
                        <Grid item>
                            <NumberField name="H13_sede_principale"
                                label="Sede principale"
                                value={state.dirittiCCIAA.H13_sede_principale}
                                className={gClasses.textFieldReadOnly}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                readOnly={true}
                            ></NumberField>
                        </Grid>
                        <Grid item>
                            <FormControl className={gClasses.formControlCCIAA}>
                                <InputLabel htmlFor="I13_maggiorazione">% Maggiorazione</InputLabel>
                                <Select
                                    className={gClasses.select}
                                    value={state.dirittiCCIAA.I13_maggiorazione}
                                    inputProps={{ name: 'I13_maggiorazione', id: 'I13_maggiorazione' }}
                                    onChange={handleChangeSelect}
                                >
                                    <MenuItem value={0}></MenuItem>
                                    <MenuItem value={20}>20%</MenuItem>
                                    <MenuItem value={70}>70%</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl className={gClasses.formControlCCIAA}>
                                <InputLabel htmlFor="J13_numero_unita_locali">Num. unità locali</InputLabel>
                                <Select
                                    className={gClasses.select}
                                    value={state.dirittiCCIAA.J13_numero_unita_locali}
                                    inputProps={{ name: 'J13_numero_unita_locali', id: 'J13_numero_unita_locali' }}
                                    onChange={handleChangeSelect}
                                >
                                    <MenuItem value={0}></MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    {/* ----------------------14-------------------- */}
                    <Grid container spacing={3} alignItems="flex-end">
                        <Grid item>
                            <FormControlLabel className={gClasses.bottomControlLabel}
                                labelPlacement="end"
                                style={{ minWidth: "18rem" }}
                                control={
                                    <Radio
                                        checked={state.dirittiCCIAA.B14_check}
                                        name='B14_check'
                                        id='B14_check'
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                        onChange={handleChangeCheckedRadio}
                                    />
                                }
                                label="S.R.L. - S.P.A."
                            />
                        </Grid>
                        <Grid item>
                            <NumberField name="H14_sede_principale"
                                label="Sede principale"
                                value={state.dirittiCCIAA.H14_sede_principale}
                                className={gClasses.textFieldReadOnly}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                readOnly={true}
                            ></NumberField>
                        </Grid>
                        <Grid item>
                            <FormControl className={gClasses.formControlCCIAA}>
                                <InputLabel htmlFor="I14_maggiorazione">% Maggiorazione</InputLabel>
                                <Select
                                    className={gClasses.select}
                                    value={state.dirittiCCIAA.I14_maggiorazione}
                                    inputProps={{ name: 'I14_maggiorazione', id: 'I14_maggiorazione' }}
                                    onChange={handleChangeSelect}
                                >
                                    <MenuItem value={0}></MenuItem>
                                    <MenuItem value={20}>20%</MenuItem>
                                    <MenuItem value={70}>70%</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl className={gClasses.formControlCCIAA}>
                                <InputLabel htmlFor="J14_numero_unita_locali">Num. unità locali</InputLabel>
                                <Select
                                    className={gClasses.select}
                                    value={state.dirittiCCIAA.J14_numero_unita_locali}
                                    inputProps={{ name: 'J14_numero_unita_locali', id: 'J14_numero_unita_locali' }}
                                    onChange={handleChangeSelect}
                                >
                                    <MenuItem value={0}></MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    {/* ----------------------14-------------------- */}
                </Grid>
            </Paper>
        </React.Fragment>
    )
}